'use client'

import { up } from 'up-fetch'

import {
  IGetLatLng,
  IPredictionsLocation,
  IResponseGetLatLng,
  IResponseGetRoute,
  IResponseLocation,
} from '../../types'

const upFetch = up(fetch)

export const useLocationApi = () => {
  const getLatLng = async (placeId?: string) => {
    if (!placeId) return null

    const res = await upFetch<IResponseGetLatLng>(
      `https://geolocation.cargoking.co.uk/google/place/details`,
      {
        params: {
          place_id: placeId,
        },
      },
    )

    return {
      address_components: res?.result?.address_components,
      location: res.result.geometry.location,
    } satisfies IGetLatLng
  }

  const getRoute = async (routes: string[]) =>
    upFetch<IResponseGetRoute>(`https://geolocation.cargoking.co.uk/google/directions`, {
      body: {
        routes,
      },
      method: 'POST',
    })

  const searchLocationInType = async (searchValue: string, type: string) =>
    upFetch<IResponseLocation>(`https://geolocation.cargoking.co.uk/google/place/autocomplete`, {
      params: {
        input: searchValue,
        // locationrestriction: 'rectangle:25.992808,-36.367566|71.006890,45.212114',
        strictbounds: 'true',
        types: type,
      },
    })

  const searchLocation = async (searchValue: string): Promise<IPredictionsLocation[]> => {
    const res = await Promise.all(
      ['locality', 'address', 'postal_code', 'establishment'].map(async type =>
        searchLocationInType(searchValue, type),
      ),
    )

    return res
      .map(data => data?.predictions)
      .filter(data => data)
      .flat(1) as IPredictionsLocation[]
  }

  return {
    getLatLng,
    getRoute,
    searchLocation,
    searchLocationInType,
  }
}
